import React from "react";
import Spinner from "./Spinner";

const SpinnerOverlay: React.FC<{ text?: string }> = ({ text }) => (
  <div
    style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "transparent",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }}
  >
    <Spinner size={60} />
    {text && (
      <div style={{ color: "#000", marginTop: 16, fontSize: 18, fontWeight: 500 }}>
        {text}
      </div>
    )}
  </div>
);

export default SpinnerOverlay; 